export default {
  industryRow1: '在正确时间和地点提供正确的信息',
  industryRow2: '有效利用人与设备之间不断涌动的数据流，并将这些数据辅助决策制定，这是数字化转型成功的条件。用事实说话，摆脱观念或假设，利用数据快速解决问题，提高产品质量，降低成本，加速转型。',
  industryRow3: '拥有现代云原生架构的助攻，杰为实时数字化链平台能够同步整个供应链中的产品生命周期信息。客户不仅对产品及过程实时可见，还可以从实时分析中受益，了解设计、工程变更、挑战带来的直接影响。',
  industryRow4: '实时反馈循环意味着设计与工程师可以对更改作出即时反馈',
  industryRow5: '使用多种设计工具及其他新兴用例，快速满足不断变化的客户需求',
  industryRow6: '连接包括遗留PLM在内的系统，实时访问信息和创新 ',
  industryRow7: '实时查看生产线状态和性能数据，提高运行效率',
  industryRow8: '杰为实时数字化链助力制造商满足当今对加快创新周期，复杂的供应链和全球竞争的需求。通过全面实时访问数据，分析和自动洞察，他们可以快速应对机会，风险和变化。',
  industryRow9: ''
}
